<template>
  <main>
    <div class="container-fluid">

      <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="willProcessToilet-tab" data-bs-toggle="pill" data-bs-target="#willProcessToilet"
            type="button" role="tab" aria-controls="willProcessToilet" aria-selected="true"> 查詢 </button>
        </li>

      </ul>

      <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
        <will-process-toilet></will-process-toilet>
      </div>
    </div>
  </main>
</template>

<script>
import willProcessToilet from './willProcessToilet.vue'




export default {
  components: { willProcessToilet},
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
 
  },
  mounted() {

  },
};
</script>

<style>
</style>
